// extracted by mini-css-extract-plugin
module.exports = {"experts":"_3AzCRXoj flex","expert-avatar":"_1N0w4H2E","expertAvatar":"_1N0w4H2E"};